import { storeClient } from 'apis/apiClients';
import { TStoreClientFeesDetail } from 'hooks';
import { TSettlementDetail } from 'pages/SalesSettlement/schema';

// 계약서 목록 조회
export const getPartnerContracts = async () => {
  const { data } = await storeClient.get(`/finance/v1/partner-contracts`);
  return data;
};

// 계약서 담당자 정보 등록
export const saveAssigneeManager = async (partnerContractIdx: number, params: unknown) => {
  const { data } = await storeClient.post(`/finance/v1/partner-contracts/${partnerContractIdx}/managers`, params);
  return data;
};

// 계약서 담당자 정보 수정
export const updateAssigneeManager = async (partnerContractIdx: number, assigneeManagerIdx: number, params: unknown) => {
  const { data } = await storeClient.put(
    `/finance/v1/partner-contracts/${partnerContractIdx}/managers/${assigneeManagerIdx}`,
    params
  );
  return data;
};

// 공동인증서 발급 요청
export const saveCertificateIssuance = async (partnerContractIdx: number, params: unknown) => {
  const { data } = await storeClient.post(`/finance/v1/partner-contracts/${partnerContractIdx}/certificates/issue`, params);
  return data;
};

// 공동인증서 발급 완료 확인
export const checkCertificateIssuance = async (params: { partnerContractIdx: number; bizAccountIdx: number }) => {
  const { data } = await storeClient.post(`/finance/v1/partner-contracts/certificates/verify`, params);
  return data;
};

// 은행 코드 목록 조회
export const getFinanceBankCodes = async () => {
  const { data } = await storeClient.get(`/finance/v1/common/bank-codes`);
  return data;
};

// 계좌 정보 변경 요청
export const savePartnerContractsBankAccount = async (partnerContractIdx: number, params: any) => {
  const { data } = await storeClient.post(`/finance/v1/partner-contracts/${partnerContractIdx}/bank-account/change`, params);
  return data;
};

// 특정 파트너 계약서의 담당자 정보 삭제.
export const deleteAssigneeManager = async (partnerContractIdx: number, assigneeManagerIdx: number) => {
  const { data } = await storeClient.delete(`/finance/v1/partner-contracts/${partnerContractIdx}/managers/${assigneeManagerIdx}`);
  return data;
};

// 매출 정산

// 정산서 목록 조회
export const getSalesSettlements = async (params: unknown) => {
  const { data } = await storeClient.get(`/finance/v1/settlements`, { params });
  return data;
};

// 정산서 조회
export const getSalesSettlementDetail = async (settlementIdx: string) => {
  const { data } = await storeClient.get<TSettlementDetail>(`/finance/v1/settlements/${settlementIdx}`);
  return data;
};

// 정산서 매출 내역 조회 (거래 건별)
export const getSettlementPerSalesHistory = async (settlementIdx: string, params: unknown) => {
  const { data } = await storeClient.get(`/finance/v1/settlements/${settlementIdx}/per-sales-history`, { params });
  return data;
};

// 정산서 매출 내역 조회 (회사 별)
export const getSettlementClientSalesHistory = async (settlementIdx: string) => {
  const { data } = await storeClient.get(`/finance/v1/settlements/${settlementIdx}/client-sales-history`);
  return data;
};

// 정산서 매출 내역 조회 (제휴점 별)
export const getSettlementPartnerSalesHistory = async (settlementIdx: string) => {
  const { data } = await storeClient.get(`/finance/v1/settlements/${settlementIdx}/partner-sales-history`);
  return data;
};

// 정산서 매출 내역 조회 (이월 거래내역)
export const getSettlementCarryOverSalesHistory = async (settlementIdx: string) => {
  const { data } = await storeClient.get(`/finance/v1/settlements/${settlementIdx}/carry-over-sales-history`);
  return data;
};

// 정산서 증빙 내역 조회
export const getSettlementEvidenceHistory = async (settlementIdx: string) => {
  const { data } = await storeClient.get(`/finance/v1/settlements/${settlementIdx}/evidence-history`);
  return data;
};

// 정산서 입금/이체 내역 조회
export const getSettlementDepositTransferHistory = async (settlementIdx: string) => {
  const { data } = await storeClient.get(`/finance/v1/settlements/${settlementIdx}/deposit-transfer-history`);
  return data;
};

// 정산서 세금계산서 발행
export const createSettlementTaxInvoice = async (settlementIdx: string) => {
  const { data } = await storeClient.post(`/finance/v1/settlements/${settlementIdx}/evidences/tax-invoice/issue`);
  return data;
};

// 증빙 내역

// 증빙 목록 조회
export const getEvidencesHistories = async (params: unknown) => {
  const { data } = await storeClient.get(`/finance/v1/evidences`, { params });
  return data;
};

// 증빙 상세 조회
export const getEvidencesDetail = async (evidenceIdx: string | number) => {
  const { data } = await storeClient.get(`/finance/v1/evidences/${evidenceIdx}`);
  return data;
};

// 증빙 현금영수증 상세 조회
export const getEvidencesCashReceiptDetail = async (evidenceIdx: string | number) => {
  const { data } = await storeClient.get(`/finance/v1/evidences/${evidenceIdx}/cash-receipt`);
  return data;
};

// 고객사 확인 > 고객사 수수료 정보 조회
export const getStoreClientFeesDetail = async (storeId: string): Promise<TStoreClientFeesDetail[]> => {
  const { data } = await storeClient.get(`/finance/v1/stores/${storeId}/client-fees`);
  return data;
};
